<app-overview>
	<app-overview-header>
		<app-overview-settings-menu />
		<app-overview-header-add (click)="openMenu()" />
		<app-overview-header-additional-options>
			<div [matTooltipDisabled]="canAddHolidays()"
				[matTooltip]="'Feiertage können nur für Projekte in Deutschland mit ausgewähltem Bundesland hinzugefügt werden' | translate: 'tooltip-holiday-restriction' : TRANSLATION_SCOPE">
			<button mat-button 
			 class="overview-header__holiday-button"
			 (click)="isHolidayMenuExpanded.set(true)" 
				[disabled]="!canAddHolidays()">
				<ogs-m3-icon icon="wand-sparkles" matButtonIcon />
				{{"Alle Feiertage" | translate : "action-holidays"}}
			</button>
			</div>
		</app-overview-header-additional-options>
		<app-overview-header-search />
		<app-overview-header-filter-chips />
		<app-overview-header-column-chips />
		<app-overview-header-operators>
			<app-overview-header-settings />
		</app-overview-header-operators>
	</app-overview-header>
	@let tableConfig = selectedTableConfig();

	@if(tableConfig && tableData().length > 0){
	<app-table>
		<app-table-header-group>
			<app-table-header-row>
				@for(header of tableConfig.columnConfig.columns; track header.field){
				@if(header.options.isVisible){
				<app-table-header [width]="header.options.widthPx">
					<app-bcl-table-header [header]="header" />
				</app-table-header>
				}
				}
			</app-table-header-row>
		</app-table-header-group>
		<app-table-data-group (dataOffsetReached)="onTableOffsetReached()">
			<app-virtual-scroll-wrapper appInfiniteScroll [itemSize]="40" [maxBufferPx]="300" [minBufferPx]="200"
				[scrollDebounceTime]="400" [scrollBufferSize]="300" (scrollBufferReach)="onTableOffsetReached()">
				@for(data of tableData(); track $index){
				<app-table-data-row *ogsItem>
					@for(header of tableConfig.columnConfig.columns; track header.field){
					@if(header.options.isVisible){
					<app-table-data [width]="header.options.widthPx">
						@let tableData = getDataForField($any(data), header);

						@if(tableData){
						<app-bcl-table-data [tableData]="tableData" (actionClick)="onEditClick(data)" />
						}
					</app-table-data>
					}
					}
				</app-table-data-row>
				}
			</app-virtual-scroll-wrapper>
		</app-table-data-group>
	</app-table>
	}
	@else {
	<app-table-skeleton />
	}
</app-overview>
<app-project-special-holiday-menu [(isExpanded)]="isHolidayMenuExpanded" (addHolidays)="addHolidays()" />
<app-project-special-time-menu [(isExpanded)]="isEditMenuExpanded" [editSpecialTime]="editSpecialTime()"
	(delete)="deleteSpecialTime($event)" (add)="addSpecialTime($event)" (update)="updateSpecialTime($event)" />
